
import { projectHighlights } from "./projectHighlights";
import formatDate from "../utils.js";
import { useTranslation } from "../../i18n/LanguageProvider";
import { projectTranslationsPt } from "./projectsTranslations";

function formatProjectDate(dateString, locale) {
  const dateObj = formatDate(dateString);

  if (dateObj === dateString) {
    return dateString;
  }

  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "long",
  }).format(dateObj);
}

function dateRange(project, locale, ongoing, na) {
  const formattedEnd = project.endDate ? formatProjectDate(project.endDate, locale) : ongoing;

  if (!project.startDate) {
    return `${na} - ${formattedEnd}`;
  }

  return `${formatProjectDate(project.startDate, locale)} - ${formattedEnd}`;
}

export default function ProjectCard({ project, publications = [] }) {
  const { isPortuguese, locale, t } = useTranslation();
  const localized = isPortuguese ? projectTranslationsPt[project.id] || {} : {};
  const title = localized.title || project.title;
  const description = localized.description || project.description;
  const content = localized.content || project.content;
  const highlight = projectHighlights[project.id];
  const language = isPortuguese ? 'pt' : 'en';
  const text = (pt, en) => isPortuguese ? pt : en;
  return (
    <div className="card project-card mb-4" id={project.id}>
      <div className="card-body">
        <h2 className="card-title">{title}</h2>

        <p className="site-metadata">{dateRange(project, locale, t('common.ongoing'), t('common.na'))}</p>

        {highlight && <>
          <p className="project-objective">{highlight.objective[language]}</p>
          {highlight.role && <p className="site-metadata">{highlight.role[language]}</p>}
          {highlight.links.length > 0 && <div className="project-links">{highlight.links.map(link => <a key={link.url} href={link.url} target="_blank" rel="noreferrer">{link[language]} <span aria-hidden="true">↗</span></a>)}</div>}
        </>}

        {description && <details className="project-details">
          <summary>{text('Sobre o projeto', 'About the project')}</summary>
          {description.split("\n").filter(paragraph => paragraph.trim()).map((paragraph, index) => <p className="card-text" key={index}>{paragraph.trim()}</p>)}
        </details>}
        {(content || publications.length > 0) && <details className="project-details">
          <summary>{project.id === 'gt-baita' ? text('Objetivos e abordagem', 'Objectives and approach') : text('Aplicações e resultados', 'Applications and results')}</summary>
          {content && <p>{content}</p>}
          {publications.length > 0 && (
            <div>
              {t('common.relatedPublications')}:
              <ul className="mb-0">
                {publications.map((publication, index) => (
                  <li key={publication.id}>
                    <a href={`/publications/${publication.id}`} target="_blank" rel="noreferrer">
                      {publication.title || publication.id}
                    </a>
                    {index === publications.length - 1 ? "." : ";"}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </details>}

        {project.advisedStudents && project.advisedStudents.length > 0 && (
          <details className="project-details">
            <summary>{t('common.advisedStudents')} ({project.advisedStudents.length})</summary>
            <ul className="mb-0">
              {project.advisedStudents.map((student, index) => (
                <li key={student.name}>
                  <a href={student.url} target="_blank" rel="noreferrer">
                    {student.name}
                  </a>
                  {index === project.advisedStudents.length - 1 ? "." : ";"}
                </li>
              ))}
            </ul>
          </details>
        )}
      </div>
    </div>
  );
}
